class CollectionRoot extends HTMLElement {
  constructor() {
    super();
    this.brandsContainer = this.querySelector('.collection-root__brands-grid');
    this.loadTopItem(this.brandsContainer, 'collection-top-brands', '#collectionTopBrands');
    this.productsContainer = this.querySelector('.collection-root__products-grid');
    this.loadTopItem(this.productsContainer, 'collection-top-products', '#collectionTopProducts');
  }

  loadTopItem(container, section, content_id) {
    const collectionHandle = window.location.href.split('/collections/')[1];
    fetch(`/collections/${collectionHandle}/?sort_by=best-selling&section_id=${section}`)
      .then((response) => {
        if (!response.ok) {
          console.log(response.status);
        }
        return response.text();
      })
      .then((text) => {
        const htmlObject = document.createElement('div');
        htmlObject.innerHTML = text;
        if (htmlObject.querySelector(content_id) !== null) {
          container.classList.remove('loading');
          container.innerHTML = htmlObject.querySelector(content_id).innerHTML;
        } else {
          container.innerHTML = `<p>${tokens.no_item}</p>`;
        }
      })
  }
}

customElements.define('collection-root', CollectionRoot);
